"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAddress = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const apigw_models_1 = require("@integration/apigw-models");
class BaseAddress extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Matches)(/^[1-9][0-9]{3} ?[A-Z]{2}$/),
    (0, apigw_models_1.Docs)({ example: '1234 BB', description: 'Valid Dutch Postal code with or without space' }),
    tslib_1.__metadata("design:type", String)
], BaseAddress.prototype, "postcode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 'Langeweg', description: 'Street name' }),
    tslib_1.__metadata("design:type", String)
], BaseAddress.prototype, "street", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'house_number' }),
    (0, apigw_models_1.Docs)({ example: '23', description: 'House number' }),
    tslib_1.__metadata("design:type", String)
], BaseAddress.prototype, "houseNumber", void 0);
exports.BaseAddress = BaseAddress;
